<template>
  <div class="out-container">
    <div id="bg-color" class="bg-color-area">
      <img :src="bgImg" alt="" class="bg">
    </div>
    <div class="container">
      <div class="download-source">
        <a class="app-store" href="https://apps.apple.com/app/apple-store/id6498875759">
          <img :src="appstoreImg" alt="Kimy App Store" />
        </a>
        <a class="google-play" href="https://play.google.com/store/apps/details?id=com.mico.lite.android">
          <img :src="googleplayImg" alt="Kimy Google Play" />
        </a>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <div class="mico-lite-logo">
            <img :src="logoImg" class="img-responsive" alt="Kimy Logo">
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-8">
          <div v-for="(banner, index) in banners" :key="index" :id="'txtCaptionPg' + (index + 1)" class="txt-caption">
            <p class="txt-title">{{ banner.title }}</p>
            <p class="txt-detail">{{ banner.desc }}</p>
          </div>
        </div>
        <div class="col-xs-4">
          <div id="inner-container">
            <div v-for="(banner, idx) in banners" :key="'s' + idx" class="section">
              <img :src="pageImages[idx]" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <nav class="nav-end navbar">
      <div class="collapse navbar-collapse" id="mico-lite-navbar-collapse-1">
        <ul class="nav navbar-nav">
          <li><a href="/kimy/terms.html" target="_blank">Terms</a></li>
          <li><a href="#">|</a></li>
          <li><a href="/kimy/privacy.html" target="_blank">Privacy</a></li>
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
import $ from 'jquery'
import bgImg from '../../common/imgs/bg.png'
import logoImg from '../../common/imgs/logo.png'
import appstoreImg from '../../common/imgs/appstore.png'
import googleplayImg from '../../common/imgs/googleplay.png'
import page1 from '../../common/imgs/page1.png'
import page2 from '../../common/imgs/page2.png'
import page3 from '../../common/imgs/page3.png'
import page4 from '../../common/imgs/page4.png'

const COLOR_CLASSES = ['firstColor', 'secondColor', 'thirdColor', 'fourthColor', 'fifthColor']

export default {
  data() {
    return {
      bgImg,
      logoImg,
      appstoreImg,
      googleplayImg,
      pageImages: [page1, page2, page3, page4]
    }
  },
  computed: {
    banners() {
      return (window.text && window.text.banners) || []
    }
  },
  mounted() {
    $(() => {
      $("#inner-container").fullpage({
        navigation: true,
        scrollingSpeed: 1000,
        continuousVertical: true,
        afterLoad: (anchorLink, index) => {
          $(`#txtCaptionPg${index}`).fadeIn("slow")
          const activeClass = COLOR_CLASSES[index - 1]
          if (activeClass) {
            $("#bg-color")
              .addClass(activeClass)
              .removeClass(COLOR_CLASSES.filter(c => c !== activeClass).join(' '))
          }
        },
        onLeave: (index) => {
          $(`#txtCaptionPg${index}`).fadeOut("slow")
        }
      })
    })
  }
}
</script>
